<template>
  <div>
    <div class="admin">
      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- menu admin -->
          <div class="col-3">
            <menu-admin></menu-admin>
          </div>
          <!-- menu admin -->

          <!-- main -->
          <div class="col-9 main">
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin">
                  <h1 class="display-5 font-weight-black">Categorías</h1>
                  <div class="acciones">
                    <v-btn large color="primary" to="/admin/agregar-categoria">
                      <v-icon class="mr-3">add</v-icon>Agregar categoría
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>

            <!-- tabla de categorías -->
            <div class="row mt-0 mb-5">
              <div class="col-12">
                <div>
                  <div
                    class="top d-flex align-items-center justify-content-between mb-3"
                  >
                    <h2 class="font-weight-black">Todas las categorías</h2>
                  </div>

                  <!-- loader -->
                  <div v-if="loaderVentas" class="text-center loader-wrap-min">
                    <div
                      class="spinner-border text-primary"
                      style="width: 75px; height: 75px"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <!-- /loader -->

                  <div v-if="!loaderVentas">
                    <!-- datatable -->
                    <v-card v-if="ventas != ''">
                      <v-card-title>
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-card-title>
                      <v-data-table
                        :headers="headers"
                        :items="categorias"
                        :search="search"
                      >
                        <template v-slot:item.acciones="{ item }">
                          <v-btn
                            class="mx-2"
                            text
                            dark
                            small
                            color="primary"
                            :to="'/admin/categoria/' + item.id + '/editar'"
                          >
                            <v-icon dark>visibility</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-card>
                    <!-- /datatable -->

                    <!-- vacio -->
                    <div v-if="ventas == ''">
                      <div class="vacio">
                        <span>No hemos encontrado ventas</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /tabla de categorías -->
          </div>
          <!-- /main -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  data() {
    return {
      categorias: [],
      loader: true,
      buscar: "",
      //Table
      search: "",
      headers: [
        {
          text: "#ID",
          align: "left",
          sortable: false,
          value: "id",
        },
        { text: "Nombre", value: "nombre" },
        { text: "Acciones", value: "acciones" },
      ],
    };
  },
  methods: {
    buscarCategoria() {
      this.loader = true;
      if (this.buscar != "") {
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=searchCategoria&search=" +
              this.buscar
          )
          .then((response) => {
            console.log(response);
            this.loader = false;
            this.categorias = response.data;
          })
          .catch((error) => console.log(error));
      } else {
        //Obtenemos las productos
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getCategorias"
          )
          .then((response) => {
            console.log(response);
            this.categorias = response.data;
            this.loader = false;
          })
          .catch((error) => console.log(error));
      }
    },
    getCategorias() {
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getCategorias"
        )
        .then((response) => {
          console.log(response);
          this.categorias = response.data;
          this.loader = false;
        })
        .catch((error) => console.log(error));
    },
    print() {
      window.print();
    },
  },
  mounted() {
    this.getCategorias();
  },
};
</script>
